import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import ProblemStatement from "@/components/sections/ProblemStatement";
import HowItWorks from "@/components/sections/HowItWorks";
import Benefits from "@/components/sections/Benefits";
import PricingPreview from "@/components/sections/PricingPreview";

export default function Home() {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <ProblemStatement />
        <HowItWorks />
        <Benefits />
        <PricingPreview />
      </main>
      <Footer />
    </div>
  );
}
